import { CommonResponse } from 'models';
import moment from 'moment';
import { DATE_HYPHEN_FORMAT } from 'utils';
import axiosClient from 'utils/axiosClient';
import {
  CounterPatternMobileOrderDisplayPayload,
  CouterPatternStoreMODisplay,
  MenuCounterPattern,
  UpdateCounterPatternMobileOrderDisplayRequestPayload,
} from './models';

const counterPatternService = {
  getMenuCounterPatternList(
    payload: CounterPatternMobileOrderDisplayPayload
  ): Promise<CommonResponse<MenuCounterPattern[]>> {
    let url = `/counter-pattern-mobile-order-displays`;
    const params = new URLSearchParams();

    // Add parameters
    params.append('menu_classification', payload.menuClassification.toString());
    params.append('menu_type', payload.menuType.toString());
    params.append('menu_name', payload.menuName);
    params.append('menu_code', payload.menuCode);
    params.append('data_date', moment(payload.dataDate).format(DATE_HYPHEN_FORMAT));
    params.append('pos_code', payload.posCode);

    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    return axiosClient.get(url);
  },
  updateMobileOrderDisplay(
    payload: UpdateCounterPatternMobileOrderDisplayRequestPayload
  ): Promise<CommonResponse<any>> {
    const url = `/counter-pattern/${payload.counterPatternId}/update-mobile-order-display`;
    return axiosClient.post(url, {
      pos_code_id: payload.posCodeId,
      mobile_order_display_flg: payload.mobileOrderDisplayFlg,
    });
  },
  getCounterPatternStoreMobileOrderDisplays(posCodeId: number): Promise<CommonResponse<CouterPatternStoreMODisplay[]>> {
    const url = `/counter-pattern-store-mobile-order-displays?pos_code_id=${posCodeId}`;
    return axiosClient.get(url);
  },
};

export default counterPatternService;
